import { Component ,Inject , OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {MatDialog, MatDialogRef} from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material';

import { FormGroup, FormControl, FormBuilder,FormArray,Validators, NgForm } from '@angular/forms';

@Component({
    selector: 'addContactDialog',
    templateUrl: 'addContactDialog.component.html',
    styleUrls: ['./addContactDialog.component.css']
  })
  
  export class AddContactDialogComponent implements OnInit {
    newContact:string ='';
    model: any = {};
    contactForm: FormGroup;
    constructor( 
    public dialogRef: MatDialogRef<AddContactDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router, public fb: FormBuilder)
    
    {}
    ngOnInit(): void {
    this.contactForm = this.fb.group({
      role:['',[Validators.required]],
      firstName:['',[Validators.required]],
      lastName:['',[Validators.required]],
      address:['', , ],
      phoneNumber:['',, ],
      town:['', , ],
      postalCode:['',],
      email:['',[Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")]],
    });

  }

  closeDialog() {
    this.dialogRef.close( this.contactForm);
  }
  
  }


// WEBPACK FOOTER //
// ./src/app/public/contacts/addContactDialog.component.ts